export default {
  base_api: "https://api.phenikaa.com/",
  // base_api: "http://54.255.70.35/",
  token: "82e2e0f4b2d790b30cf2916d1bf664bdb3620149",
  GA_ID: "G-C3YJ5H47YW"
}
